import Vue from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';

// 初始化 Pinia
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

export default pinia;
